/**
 * DevExtreme (esm/ui/grid_core/keyboard_navigation/const.js)
 * Version: 22.2.5
 * Build date: Mon Mar 27 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var ATTRIBUTES = {
    ariaColIndex: "aria-colindex",
    dragCell: "dx-drag-cell"
};
